import { Dispatch } from 'redux';
import actions from './actions';

import { AnchorAPI } from '../../../modules/AnchorAPI';

import { Episode } from '../../../types';

import { Browser } from '../../../modules/Browser';

const { setEpisodeListStatus, setEpisodePendingDeletion } = actions;

const fetchAndLoadEpisodes = () => (dispatch: Dispatch<any>) => {
  dispatch(
    setEpisodeListStatus({
      kind: 'episodeListLoading',
    })
  );
  AnchorAPI.fetchPodcastEpisodeList({ limit: 3000, page: 1 })
    .then(json => {
      dispatch(
        setEpisodeListStatus({
          kind: 'episodeListLoaded',
          episodes: json.episodes.map(episode => {
            const { publishOn } = episode;
            function getPublishStatus() {
              if (publishOn === null) return 'draft';
              if (new Date(publishOn) < new Date()) return 'published';
              return 'scheduled';
            }
            return { ...episode, publishStatus: getPublishStatus() };
          }),
        })
      );
    })
    .catch(() => {
      dispatch(
        setEpisodeListStatus({
          kind: 'episodeListFailed',
        })
      );
    });
};
const deleteAndFetchAndLoadEpisodes = (episode: Episode) => (
  dispatch: Dispatch<any>
) => {
  dispatch(setEpisodePendingDeletion(null));
  AnchorAPI.deleteEpisode(episode.episodeId).then((response: any) => {
    dispatch(setEpisodePendingDeletion(null));
    fetchAndLoadEpisodes()(dispatch);
  });
  // TODO: DO SOMETHING HERE!
  // .catch(err => {
  // });
};

const onPressRequestDeleteEpisode = (episode: Episode) => (
  dispatch: Dispatch<any>
) => {
  dispatch(setEpisodePendingDeletion(episode));
};
const onPressConfirmDeleteEpisode = deleteAndFetchAndLoadEpisodes;
const onPressDownloadEpisode = (episode: Episode) => (
  dispatch: Dispatch<any>
) => {
  if (episode.publishStatus === 'published') {
    // TODO: This should be in its own module
    const url: string = episode.downloadUrl;
    const a: HTMLAnchorElement = document.createElement('a');
    a.href = url;
    const fileName = episode.title || 'Untitled';
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
};
const onPressCopyEpisodeLink = (episode: Episode) => (
  dispatch: Dispatch<any>
) => {
  const { shareLinkPath } = episode;
  const url = episode.isPublishedToSpotifyExclusively
    ? shareLinkPath
    : Browser.getFullUrlForUrlPath(shareLinkPath);
  Browser.copyTextToClipboard(url);
};
const onPressCloseConfirmDeleteModal = () => (dispatch: Dispatch<any>) => {
  dispatch(setEpisodePendingDeletion(null));
};

export default {
  fetchAndLoadEpisodes,
  onPressCloseConfirmDeleteModal,
  onPressConfirmDeleteEpisode,
  onPressCopyEpisodeLink,
  onPressDownloadEpisode,
  onPressRequestDeleteEpisode,
};
